import { render } from "./Book.vue?vue&type=template&id=c4296702&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import "./Book.vue?vue&type=style&index=0&id=c4296702&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4296702"]])

export default __exports__